import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { getAllMembers } from "app/services/distributorService";

const MemberSearch = ({ setFieldValue }) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  // Handle input change
  const handleInputChange = (value) => {
    setInputValue(value);
  };

  // Handle option change
  const handleChange = (value) => {
    setSelectedValue(value);
    setFieldValue("memId", value.id);
    setFieldValue("balance", value.balance);
  };

  // Load options with API call
  const loadOptions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await getAllMembers(inputValue);
    const memberData = [];

    if (data?.data?.length > 0) {
      data.data
        .filter((item) => item.memberType === "Merchant")
        .forEach((item) => {
          memberData.push({
            id: item.memId,
            label: `${item.uniqueIdentity} - ${item.company} - ${item.memberMobileNo} - ${item.memberType}`,
            balance: `${item.balance}`,
          });
        });
    }

    return memberData;
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name="memId"
    />
  );
};

export default MemberSearch;
